// extracted by mini-css-extract-plugin
module.exports = {"SettingCard":"SettingCard_SettingCard__2SpNv","SettingCard__Text":"SettingCard_SettingCard__Text__1myj1"};